















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import BaseRepository from "../../core/HttpResources/BaseRepository";
import BTableColumn from '../../models/base/BTableColumn.model';
import SyncAlertasResult from '@/models/hogar/alertas.model';
import Helpers from '@/helpers/helper';
@Component({})
export default class AlertasDelHogar extends BaseVue {
  @Prop() readonly codigoHogar!: string;
  @Prop() readonly title!: string;
  requester = new BaseHttpClient("hogar");
  loading = false;
  sync = new SyncAlertasResult();
  constructor() {
    super();
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoHogar",
        "string",
        true,
        "Número del hogar"
      ),
      new TipoTramiteComponentProp("title", "string", true, "Título")
    );
    this.$emit("render", props);
  }
  verNotaInfo() {
    let _this = this as any;
    _this.$buefy.dialog.alert({
      title: "Nota sobre alertas",
      message: `Las alertas vigentes aparecen siempre encabezando las listas con un color de letra amarillo.`,
      type: "is-info",
      hasIcon: true,
      icon: "info-circle",
      iconPack: "fa"
    });
  }
  get vigentes(){
      return this.sync.alertas + this.sync.observaciones + this.sync.sanciones;
  }
  async syncAlertas() {
    this.sync = new SyncAlertasResult();
    this.$store.commit("setLoadingAlertasHogar", true);
    try {
      this.sync = await this.requester.getAsync<SyncAlertasResult>("alertas/sync", {
        codigoHogar: this.codigoHogar
      });
      this.$store.commit("setAlertasHogar", this.vigentes);
    } catch (e) {
      this.$store.commit("setAlertasHogar", 0);
      this.operationFailedErrors(e);
    } finally {
      this.$store.commit("setLoadingAlertasHogar", false);
    }
  }
  @Watch("codigoHogar", { immediate: true })
  onPersonaIdChange(value: string) {
    if (!value) return;
    this.syncAlertas();
  }
}

